import axios from "axios";

let MASTER_API_URL;
if (process.env.REACT_APP_NODE_ENV === "local") {
  MASTER_API_URL = process.env.REACT_APP_MASTER_API_URL;
} else {
  MASTER_API_URL = process.env.REACT_APP_API_URL + "masters";
}

export async function getAllRecordsPCategory() {
  const response = await axios
    .get(MASTER_API_URL + "/pcategory/get")
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

export async function getPNOActive() {
  const response = await axios
    .get(MASTER_API_URL + "/pcategory/activepno")
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });

  return response.data;
}

export const AddNewPCategory = async (pcategory) => {
  let url = `${MASTER_API_URL}/pcategory`;
  const response = await axios
    .post(url, pcategory)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export const UpdatePCategory = async (pcategory) => {
  let url = `${MASTER_API_URL}/pcategory/update`;
  const response = await axios
    .post(url, pcategory)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export async function DeletePCategory(skid) {
  let url = `${MASTER_API_URL}/pcategory/delete`;
  const resp = await axios
    .post(url)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.message;
    });
  return resp;
}

export async function getPcatByPno(pno) {
  const response = await axios.post(MASTER_API_URL + "/pcategory/getpcatbypno", pno)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}